import { useState } from "react";
import Modal from "components/ui/modal/modal";
import Button from "components/ui/controls/button/button";
import { FaCogs } from "react-icons/fa";
import ContributionSpecifique from "components/app/AuditComplet/SituationPro/ContributionSpecifique";
import ActionButton from "components/ui/controls/action-button/ActionButton";
import Column from "components/ui/layout/column/column";

function ContributionSpecifiquePageModal(props) {
  const [modalOpen, setmodalOpen] = useState(false);

  return (
    <>
    <Column>
    
    <ActionButton onClick={() => setmodalOpen(true)} icon={FaCogs} title="Ajouter une contribution spécifique" />
    </Column>
      <Modal
        width="80%"
        height="80%"
        title="Contribution spécifique"
        icon={<FaCogs />}
        visible={modalOpen}
        onClose={() => {
          setmodalOpen(false);
        }}
      >
        <ContributionSpecifique
        Outil={props.Outil}
        ClientConjoint={props.ClientConjoint}
          onClose={() => {
            setmodalOpen(false);
          }}
        />
      </Modal>
    </>
  );
}

export default ContributionSpecifiquePageModal;
